import { render, staticRenderFns } from "./GmbCategory.vue?vue&type=template&id=08cc23f3&scoped=true&"
import script from "./GmbCategory.vue?vue&type=script&lang=js&"
export * from "./GmbCategory.vue?vue&type=script&lang=js&"
import style0 from "./GmbCategory.vue?vue&type=style&index=0&id=08cc23f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc23f3",
  null
  
)

export default component.exports